import CustomField, {
  ICustomField,
  ICustomFieldApiModel,
} from '@models/CustomField.model';

export interface IField {
  id: string;
  content: string;
  equipmentId: string;
  customFieldId: string;
  customField?: ICustomField;
  createdAt: Date;
  updatedAt: Date;
}

export interface IFieldApiModel {
  id: string;
  content: string;
  equipmentId: string;
  customFieldId: string;
  customField?: ICustomFieldApiModel;
  createdAt: string;
  updatedAt: string;
}
export interface IFieldApiModel2 {
  // Nullable Because of agg
  id: string;
  content: string | null;
  customFieldId: string;
}
export default class Field implements IField {
  public readonly id: string;

  public readonly content: string;

  public readonly equipmentId: string;

  public readonly customFieldId: string;

  public readonly customField?: ICustomField;

  public readonly createdAt: Date;

  public readonly updatedAt: Date;

  constructor(
    id: string,
    content: string,
    equipmentId: string,
    customFieldId: string,
    createdAt: Date,
    updatedAt: Date,
    customField?: ICustomField,
  ) {
    this.id = id;
    this.content = content;
    this.equipmentId = equipmentId;
    this.customFieldId = customFieldId;
    this.customField = customField;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  static fromApiModel(apiModel: IFieldApiModel): IField {
    const { id, content, equipmentId, customFieldId } = apiModel;

    const createdAt = new Date(Date.parse(apiModel.createdAt));
    const updatedAt = new Date(Date.parse(apiModel.updatedAt));
    const customField = apiModel.customField
      ? CustomField.fromApiModel(apiModel.customField)
      : undefined;
    return new Field(
      id,
      content,
      equipmentId,
      customFieldId,
      createdAt,
      updatedAt,
      customField,
    );
  }

  static arrayFromApiModel(arrayApiModel: IFieldApiModel[]) {
    const array = arrayApiModel.map(apiModel => Field.fromApiModel(apiModel));

    return array;
  }
}
